import { render, staticRenderFns } from "./AddQuestionDialog.vue?vue&type=template&id=47beb537&scoped=true&"
import script from "./AddQuestionDialog.vue?vue&type=script&lang=js&"
export * from "./AddQuestionDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddQuestionDialog.vue?vue&type=style&index=0&id=47beb537&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47beb537",
  null
  
)

export default component.exports